<template>
  <div
    class="w-full flex justify-center items-center p-2 min-h-14 text-n-0 font-body transition-colors rounded-lg"
  >
    <div class="w-full flex justify-center items-center gap-3">
      <div class="flex justify-between items-start w-full gap-1">
        <div class="flex flex-col font-heading text-sm font-medium">
          <div>{{ product.name }}</div>
          <div class="text-n-200">
            {{ description }}
          </div>
          <div v-if="product.discountType === '2x1'" class="text-g-500 text-sm">
            <!-- eslint-disable-next-line -->
            {{ '2x1' }}
            <span v-if="product.quantity > 1"> ({{ product.discountAmount }}) </span>
          </div>
        </div>

        <div class="font-bold font-text text-xs flex items-center gap-3 shrink-0">
          <div class="flex flex-col">
            <div v-if="product.discountType" class="font-body text-xs line-through">
              <span>
                {{ currency(product.originalPrice * product.quantity) }}
              </span>
            </div>
            <div v-if="product.discountType === '2x1'">
              {{ currency(product.originalPrice * (product.quantity - product.discountAmount!)) }}
            </div>
            <div v-else>
              {{ currency(product.price * product.quantity) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useMoney } from '@/composables/useMoney'
import type { BillProduct } from '@/types'

type Props = {
  product: BillProduct
}

const props = defineProps<Props>()

const { currency } = useMoney()

const description = computed(() => {
  return [...(props.product.comboProducts || props.product.modifiers || [])]
    .map(modifier => {
      const quantity = modifier.quantity > 1 ? ` x ${modifier.quantity}` : ''
      return modifier.name + quantity
    })
    .join(', ')
})
</script>
